import { LatLngExpression } from "leaflet";
import React from "react";
import { useEffect, useState } from "react";
import { Circle, useMap } from "react-leaflet";

interface DraggableCircleProps {
  center: LatLngExpression;
  radius: number;
  pathOptions: L.PathOptions;
  onDragEnd: (result: { lat: number; lng: number; index: number }) => void; 
  index: number; 
}

const DraggableCircle = ({ center, radius, pathOptions, onDragEnd, index }: Readonly<DraggableCircleProps>) => {
  const [dragging, setDragging] = useState<boolean>(false);
  const [circleCenter, setCircleCenter] = useState<LatLngExpression>(center);
  const map = useMap();

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (dragging) {
        const latlng = map.mouseEventToLatLng(e);
        setCircleCenter([latlng.lat, latlng.lng]);
      }
    };

    const handleMouseUp = (e: MouseEvent) => {
      if (dragging) {
        setDragging(false);
        map.dragging.enable();
        const latlng = map.mouseEventToLatLng(e);
        onDragEnd({ lat: latlng.lat, lng: latlng.lng, index });
      }
    };

    if (dragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [dragging, map, onDragEnd, index]);

  const handleMouseDown = (e: L.LeafletMouseEvent) => {
    setDragging(true);
    map.dragging.disable();
  };

  return (
    <Circle
      center={circleCenter}
      radius={radius}
      pathOptions={pathOptions}
      eventHandlers={{
        mousedown: handleMouseDown,
      }}
    />
  );
};

export { DraggableCircle };